import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import { HTMLView } from 'components/atoms/htmlView';
import { useMediaQuery } from 'react-responsive';
import ArrowCoral from 'assets/images/RIGHT.png';

const IntroCard = props => {
  const {
    description_trim_length,
    data,
    description_trim_length_mobile,
    callingFrom,
    showJoinButton = false,
    join_team_link,
  } = props;

  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });

  if (!data) {
    return null;
  }

  const handleJoinClick = link => {
    window.open(link);
  };
  const title = 'Meet The Team';

  return (
    <div>
      {isMobile ? (
        <div className={'introCard'}>
          <HTMLView
            tagName={'h2'}
            className={'title'}
            html={props.data.vertical_id === 10 ? title : data.title}
          />
          {callingFrom !== 'product-browser' && // Removing Intro From the Product Browser Mobile
            (description_trim_length_mobile ? (
              <Dotdotdot clamp={description_trim_length_mobile} tagName={'div'}>
                <HTMLView
                  tagName={'p'}
                  className={'intro_description'}
                  html={data.mobile_description}
                />
              </Dotdotdot>
            ) : (
              <HTMLView
                tagName={'p'}
                className={'intro_description'}
                html={data.mobile_description}
              />
            ))}
        </div>
      ) : (
        <div className={'introCard'}>
          <HTMLView tagName={'h1'} className={'title'} html={data.title} />
          <HTMLView
            tagName={'span'}
            className={'tag-word'}
            html={data.tag_word}
          />
          {description_trim_length ? (
            <Dotdotdot clamp={description_trim_length} tagName={'div'}>
              <HTMLView
                tagName={'p'}
                className={'intro_description'}
                html={data.description}
              />
            </Dotdotdot>
          ) : (
            <HTMLView
              tagName={'p'}
              className={'intro_description'}
              html={data.description}
            />
          )}
          {showJoinButton && join_team_link && (
            <div className={'join-button'}>
              <button
                className={'join'}
                onClick={() => handleJoinClick(join_team_link)}
              >
                <span>CAREERS</span>
                <img src={ArrowCoral} alt={'arrow'} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default IntroCard;
